<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="80%"
  >
    <v-card elevation="2">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>{{ getTitle }}</span>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <embed
          :src="pdfUrl"
          width="100%"
          height="700px"
          type="application/pdf"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PdfViewerDialog",
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String,
      default: ""
    },
    pdfType: {
      type: String,
      default: ""
    }
  },

  computed: {
    getTitle() {
      const titles = {
        teach: "ใบอนุญาตประกอบวิชาชีพครู",
        director: "ใบอนุญาตประกอบวิชาชีพผู้บริหาร",
        contract: "สัญญาจ้างพนักงานราชการ"
      };
      return titles[this.pdfType] || "เอกสาร PDF";
    }
  }
};
</script>